export function OutsidePeriodBanner({count, onShowAll}: { count: number, onShowAll: () => void }) {
    if (count <= 0) {
        return null;
    }

    return (
        <p className="mb-3 text-xs text-gray-500">
            {count === 1 ? '1 document valt' : `${count} documenten vallen`} buiten deze periode.{' '}
            <button
                type="button"
                onClick={onShowAll}
                className="font-semibold text-primary underline underline-offset-2 transition-opacity hover:opacity-80"
            >
                Toon alle
            </button>
        </p>
    );
}
